// Tiny formatters shared by the wallet pages. Kept dependency-free so the
// portal bundle stays small and predictable.

export function formatMoney(value: number, quote: 'EUR' | 'USD'): string {
  const locale = quote === 'EUR' ? 'es-ES' : 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: quote,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatTokenAmount(raw: string, opts: { maxFraction?: number } = {}): string {
  const max = opts.maxFraction ?? 6;
  const num = Number(raw);
  if (!Number.isFinite(num)) return raw;
  if (num === 0) return '0';
  // Use compact rendering for large values, decimal for tokens.
  if (num >= 10_000) return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
  return num.toLocaleString('en-US', { maximumFractionDigits: max });
}

export function formatPct(pct: number): string {
  if (!Number.isFinite(pct)) return '—';
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toFixed(2)} %`;
}

export function shortenAddress(addr: string, head = 6, tail = 4): string {
  if (!addr) return '';
  if (addr.length <= head + tail + 1) return addr;
  return `${addr.slice(0, head)}…${addr.slice(-tail)}`;
}
